import { SET_ORCHESTRATOR } from '../constants';
import { clamp } from '@immutabl3/utils';
import data from './data.js';

// a smooth scroll 
// biggest alteration is to pre-generate array of steps to 
// allow us to bail if the scroll isn't what we expect

const INTERVAL = 1000 / 60;

const { PI, cos, abs, round } = Math;

const ease = k => 0.5 * (1 - cos(PI * k));

const now = Date.now;

const hasDeviated = (a, b, margin = 1) => abs(round(a) - round(b)) > margin;

let activeScroll;
let orchestrator;

const step = function(config) {
  const {
    index,
    steps,
  } = config;

  if (!steps[index]) return config.onComplete();

  const [x, y] = steps[index];

  if (steps[index - 1]) {
    const [x, y] = steps[index - 1];
    
    const { top } = data;
    if (hasDeviated(top, y)) {
      return config.onComplete(); // console.log('break:y', top, y);
    }
    
    const { left } = data;
    if (hasDeviated(left, x)) {
      return config.onComplete(); // console.log('break:x', left, x);
    }
  }

  orchestrator.jumpTo({
    top: y,
    left: x,
  });

  config.index += 1;

  config.raf = globalThis.requestAnimationFrame(() => step(config));
};

const animateScroll = function(config) {
  step(config);
  return {
    cancel() {
      cancelAnimationFrame(config.raf);
    },
  };
};

const generate = function({
  x,
  y,
  duration,
}) {
  const startTime = now();
  const {
    top: startY,
    left: startX,
  } = data;
  // ms into frames
  const maxIterations = Math.ceil((duration / 1000) / (1 / 60));

  let time = now();
  let iterations = 0;

  const steps = [];

  while (iterations++ < maxIterations) {
    // avoid elapsed times higher than one
    const elapsed = clamp((time - startTime) / duration, 0, 1);
    
    // apply easing to elapsed time
    const value = ease(elapsed);

    const currentX = startX + (x - startX) * value;
    const currentY = startY + (y - startY) * value;

    steps.push([currentX, currentY]);

    time += INTERVAL;

    // scroll more if we have not reached our destination
    const shouldContinue = currentX !== x || currentY !== y;
    if (!shouldContinue) break;
  }

  return steps;
};

export const scrollTo = function({
  left = 0,
  top = 0,
  duration = 468,
} = {}) {
  if (activeScroll) activeScroll.cancel();
  if (!duration) orchestrator.jumpTo({ left, top });
  activeScroll = animateScroll({
    index: 0,
    steps: generate({
      x: left,
      y: top,
      duration,  
    }),
    onComplete() {
      activeScroll = undefined;
    },
  });
};

scrollTo[SET_ORCHESTRATOR] = value => (orchestrator = value);